/**
 * Static lat/lon lookup for the most common Costa Blanca / Calida / Almeria
 * locations. The XML feed doesn't include coordinates, so we geocode by city
 * name client-side rather than hammering a paid service per property.
 *
 * Properties whose location isn't in this table simply don't get a pin on the
 * map (we still show them in the list). New locations can be added here as
 * they appear — `node scripts/find-missing-cities.js` would be a future helper.
 */
const COORDS = {
  // Costa Blanca North
  'denia': [38.8409, 0.1058],
  'javea': [38.7902, 0.1660],
  'jávea': [38.7902, 0.1660],
  'xabia': [38.7902, 0.1660],
  'moraira': [38.6885, 0.1349],
  'teulada': [38.7280, 0.1015],
  'benitachell': [38.7390, 0.1722],
  'calpe': [38.6444, 0.0445],
  'altea': [38.5994, -0.0524],
  'albir': [38.5704, -0.0762],
  'l\'alfas del pi': [38.5814, -0.1042],
  'benidorm': [38.5411, -0.1225],
  'finestrat': [38.5651, -0.2128],
  'la nucia': [38.6135, -0.1257],
  'polop': [38.6261, -0.1316],
  // Costa Blanca South
  'alicante': [38.3460, -0.4907],
  'el campello': [38.4290, -0.4030],
  'san juan': [38.4140, -0.4280],
  'elche': [38.2622, -0.7011],
  'elx': [38.2622, -0.7011],
  'santa pola': [38.1929, -0.5660],
  'gran alacant': [38.2470, -0.5340],
  'guardamar del segura': [38.0876, -0.6534],
  'torrevieja': [37.9787, -0.6824],
  'la mata': [38.0144, -0.6691],
  'orihuela costa': [37.9263, -0.7423],
  'orihuela': [38.0848, -0.9446],
  'punta prima': [37.9376, -0.7178],
  'cabo roig': [37.9001, -0.7400],
  'campoamor': [37.8810, -0.7611],
  'los altos': [37.9560, -0.7080],
  'la zenia': [37.9215, -0.7405],
  'playa flamenca': [37.9244, -0.7340],
  'villamartin': [37.9436, -0.7541],
  'rojales': [38.0867, -0.7235],
  'ciudad quesada': [38.0683, -0.7152],
  'algorfa': [38.0962, -0.7677],
  'la finca': [38.1031, -0.7800],
  'benijofar': [38.0793, -0.7256],
  'formentera del segura': [38.0853, -0.7470],
  'pilar de la horadada': [37.8703, -0.7902],
  'san miguel de salinas': [37.9846, -0.7910],
  // Costa Calida
  'san pedro del pinatar': [37.8281, -0.7783],
  'san javier': [37.8060, -0.8369],
  'los alcazares': [37.7475, -0.8527],
  'cartagena': [37.6056, -0.9817],
  'mar de cristal': [37.6398, -0.7253],
  'la manga del mar menor': [37.6517, -0.7338],
  'la manga': [37.6517, -0.7338],
  'mazarron': [37.5982, -1.3145],
  'mazarrón': [37.5982, -1.3145],
  'puerto de mazarron': [37.5644, -1.2624],
  'aguilas': [37.4081, -1.5828],
  'águilas': [37.4081, -1.5828],
  'condado de alhama': [37.8434, -1.4214],
  'sucina': [37.9300, -0.9978],
  // Costa Almeria
  'vera': [37.2491, -1.8688],
  'vera playa': [37.2326, -1.7950],
  'mojacar': [37.1414, -1.8569],
  'mojácar': [37.1414, -1.8569],
  'garrucha': [37.1827, -1.8232],
  'palomares': [37.2298, -1.8014],
  'almeria': [36.8381, -2.4597],
  'almería': [36.8381, -2.4597],
  // Valencia
  'valencia': [39.4699, -0.3763],
  'gandia': [38.9655, -0.1810],
  'oliva': [38.9229, -0.1167],
  'cullera': [39.1655, -0.2476],
};

const normalise = (s) => (s || '')
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .trim();

export const cityToLatLng = (location) => {
  if (!location) return null;
  const key = normalise(location);
  if (COORDS[key]) return COORDS[key];
  // Try first comma-segment (handles "Orihuela, Alicante")
  const first = key.split(',')[0].trim();
  if (COORDS[first]) return COORDS[first];
  // Try last comma-segment
  const last = key.split(',').pop().trim();
  if (COORDS[last]) return COORDS[last];
  return null;
};

export default COORDS;
